var map = {
	"./background_004.svg": "2697",
	"./background_005.svg": "8c59",
	"./icon_004.svg": "8df45",
	"./line_003.svg": "d382",
	"./logo-animasjon-loop.gif": "7f7d",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo_sbs.jpg": "dab7",
	"./norbotics-favicon-150x150.png": "1951",
	"./norbotics-favicon-white.png": "4268",
	"./norbotics-favicon.png": "8c7e",
	"./norbotics_logo.svg": "18b6",
	"./norbotics_logo_invertion.svg": "f380",
	"./norway-flag-icon-64.png": "c24f",
	"./photo-1553341640-6b28ff92098a.jpg": "a539",
	"./start_002.svg": "d2de",
	"./start_004.svg": "b799",
	"./start_006.svg": "fce5",
	"./united-kingdom-flag-icon-64.png": "ffc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";